import React from 'react';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';
import compose from 'recompose/compose';
import {bindActionCreators} from 'redux';
import setDisplayName from 'recompose/setDisplayName';
import {Container, Dropdown, Grid} from 'semantic-ui-react';
import {requestPrizeAction} from 'pages/EditPrize/actions';
import {resourcesSelector} from 'resources/selectors';
import {SiteNameKeys} from 'utils/DBUtils';

const mapStateToProps = state => {
  const {currentPrizeId} = state.editPrize;
  const prize = resourcesSelector(state.resources)[currentPrizeId];

  const currentSite = prize ? SiteNameKeys[prize.lang] : null;
  const options = (prize.relatedPrizes || []).map(({id, lang}) => ({id, name: SiteNameKeys[lang]}));

  return {
    currentPrizeId,
    currentSite,
    options
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  toggleSite: (event, {value}) => requestPrizeAction(value, true)
}, dispatch);

export default compose(
  setDisplayName('PrizeSitesDropdown'),
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(props => (
  <Dropdown
    className='db-filter-dropdown prizing-sites-dropdown'
    fluid
    selection
    closeOnBlur
    closeOnChange
    openOnFocus={false}
    value={props.currentPrizeId}
    disabled={!props.options.length}
    text={props.intl.formatMessage({id: props.currentSite})}>
    <Dropdown.Menu>
      {props.options.map(({id, name}) => {
        const message = props.intl.formatMessage({id: name});
        return (
          <Dropdown.Item
            key={id}
            value={id}
            text={message}
            content={<p className='filter-option' key={name}>{message}</p>}
            onClick={props.toggleSite} />
        );
      })}
    </Dropdown.Menu>
  </Dropdown>
));



// WEBPACK FOOTER //
// ./public/components/prizes/PrizeSitesDropdown.js